import React, { useEffect, useState, useMemo } from 'react';
import { filterDeep } from 'deepdash-es/standalone';
import _ from 'lodash';
import {
  DatabaseOutlined,
  FileImageOutlined,
  MenuOutlined,
  SettingOutlined,
  DiffOutlined,
  CustomerServiceOutlined,
  UsergroupDeleteOutlined,
  BookOutlined,
  AppstoreOutlined,
  UserSwitchOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { Profile } from './components';

const { Sider } = Layout;

const Sidebar = ({ credentials }) => {
  const [credential, setCredential] = useState(credentials);

  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    setCredential(credentials);
  }, [credentials]);

  const [menus] = useState(() => [
    {
      key: '1',
      icon: <DatabaseOutlined />,
      label: 'مدیریت محتوا',
      children: [
        {
          key: '10',
          icon: <FileImageOutlined />,
          label: 'مدیریت اسلایدشو',
          children: [
            {
              key: '100',
              path: 'cms/slideshow-list',
              permission: 'sliders.index',
              label: <Link to='/cms/slideshow-list'> لیست اسلایدشو</Link>,
            },
            {
              key: '101',
              path: 'cms/slider-list',
              permission: 'galleries.show',
              label: <Link to='/cms/slider-list'>(برنامه نویس) لیست گالری اسلایدشو</Link>,
            },
          ],
        },
        {
          key: '11',
          icon: <MenuOutlined />,
          label: 'مدیریت منو',
          children: [
            {
              key: '111',
              path: 'cms/menu-items',
              permission: 'menu-items.index',
              label: <Link to='/cms/menu-items'> لیست آیتم های منو</Link>,
            },
            {
              key: '112',
              path: 'cms/menu-list',
              permission: 'menus.show',
              label: <Link to='/cms/menu-list'>(برنامه نویس) لیست منوها</Link>,
            },
          ],
        },
        {
          key: '13',
          icon: <DiffOutlined />,
          label: 'مدیریت صفحات',
          children: [
            {
              key: '131',
              path: 'cms/pages',
              permission: 'pages.index',
              label: <Link to='/cms/pages'> لیست صفحات</Link>,
            },
          ],
        },
        {
          key: '12',
          icon: <SettingOutlined />,
          label: 'مدیریت تنظیمات',
          children: [
            {
              key: '121',
              path: 'cms/settings',
              permission: 'settings.index',
              label: <Link to='/cms/settings'> لیست تنظیمات</Link>,
            },
            {
              key: '122',
              path: 'cms/setting-sections',
              permission: 'setting-sections.show',
              label: <Link to='/cms/setting-sections'>(برنامه نویس) لیست قسمت های تنظیمات</Link>,
            },
          ],
        },
        {
          key: '14',
          icon: <FileTextOutlined />,
          label: 'مدیریت وبلاگ',
          children: [
            {
              key: '141',
              path: 'cms/blogs',
              permission: 'blogs.index',
              label: <Link to='/cms/blogs'> لیست وبلاگ ها</Link>,
            },
          ],
        },
      ],
    },
    {
      key: '2',
      icon: <AppstoreOutlined />,
      label: 'مدیریت خدمات',
      children: [
        {
          key: '20',
          icon: <CustomerServiceOutlined />,
          label: 'مدیریت سرویس ها',
          children: [
            {
              key: '200',
              path: 'salon-management/service-categories',
              permission: 'service-categories.index',
              label: <Link to='/salon-management/service-categories'> لیست کتگوری سرویس ها</Link>,
            },
            {
              key: '201',
              path: 'salon-management/services',
              permission: 'services.index',
              label: <Link to='/salon-management/services'>لیست سرویس ها</Link>,
            },
          ],
        },
        {
          key: '21',
          icon: <CustomerServiceOutlined />,
          label: 'مدیریت درخواست های مشاوره',
          children: [
            {
              key: '210',
              path: 'salon-management/contact-form',
              permission: 'contact-form.index',
              label: <Link to='/salon-management/contact-forms'> لیست درخواست های مشاوره</Link>,
            },
          ],
        },
      ],
    },
    {
      key: '3',
      icon: <UsergroupDeleteOutlined />,
      label: 'مدیریت مشتریان',
      children: [
        {
          key: '30',
          path: 'customer-management/customers',
          permission: 'customers.index',
          label: <Link to='/customer-management/customers'> لیست مشتریان</Link>,
        },
        {
          key: '31',
          path: 'customer-management/discounts',
          permission: 'discounts.index',
          label: <Link to='/customer-management/discounts'> لیست تخفیف ها</Link>,
        },
      ],
    },
    {
      key: '4',
      icon: <BookOutlined />,
      label: 'مدیریت آموزش آنلاین',
      children: [
        {
          key: '40',
          path: 'course-management/videos',
          permission: 'videos.index',
          label: <Link to='/course-management/videos'> لیست ویدیوها</Link>,
        },
        {
          key: '41',
          path: 'course-management/courses',
          permission: 'courses.index',
          label: <Link to='/course-management/courses'> لیست دوره ها</Link>,
        },
        {
          key: '42',
          path: 'course-management/certificate-files',
          permission: 'certificate-files.index',
          label: <Link to='/course-management/certificate-files'> لیست مدرک ها</Link>,
        },
      ],
    },
    {
      key: '5',
      icon: <UserSwitchOutlined />,
      label: 'مدیریت  دسترسی',
      children: [
        {
          key: '50',
          path: 'access-management/roles',
          permission: 'roles.index',
          label: <Link to='/access-management/roles'> لیست نقش ها</Link>,
        },
        {
          key: '51',
          path: 'access-management/users',
          permission: 'users.index',
          label: <Link to='/access-management/users'> لیست کاربران</Link>,
        },
      ],
    },
  ]);
  const [pages, setPages] = useState([]);
  const [current, setCurrent] = useState('');

  const onClick = (e) => {
    setCurrent(e.key);
  };

  useEffect(() => {
    const firstChild = menus.find((menu) => window.location.href.includes(menu.path));
    if (firstChild) {
      setCurrent(firstChild.key);
    } else {
      const secondChild = menus.find((menu) =>
        menu?.children?.find((submenu) => window.location.href.includes(submenu?.path)),
      );
      if (secondChild) {
        setCurrent(secondChild.key);
      } else {
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].children?.length > 0) {
            for (let j = 0; j < menus[i].children.length; j++) {
              if (menus[i].children[j]?.children?.length > 0) {
                for (let k = 0; k < menus[i].children[j].children.length; k++) {
                  if (window.location.href.includes(menus[i].children[j].children[k].path)) {
                    setCurrent(menus[i].children[j].children[k].key);
                  }
                }
              }
            }
          }
        }
      }
    }
  }, [window.location.href]);

  useEffect(() => {
    setPermissions(_.get(credential.user, 'permissions', []));
  }, [credential]);

  useEffect(() => {
    if (permissions.length > 0 && menus.length > 0)
      setPages(
        filterDeep(
          menus,
          (value) => {
            if (value) {
              if (permissions.find((permission) => permission.name === value.permission)?.id) {
                return true;
              }
              return false;
            }
            return false;
          },
          { childrenPath: 'children', checkCircular: false },
        ),
      );
  }, [permissions, menus]);

  return (
    <Sider theme='dark' breakpoint='lg' collapsedWidth='0' style={{ minHeight: '100%' }} width={300}>
      <div className='logo'>
        <Profile credentials={credential} />
      </div>
      <Menu
        theme='dark'
        mode='inline'
        items={pages}
        onClick={onClick}
        selectedKeys={[current]}
        style={{ minHeight: '100vh' }}
      />
    </Sider>
  );
};

export default Sidebar;
